import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  z-index: 6;
  top: 15px;
  text-align: center;
  left: 40%;

  input {
    border-radius: 5px;
    width: 80%;
    background: whitesmoke;
    padding: 10px;
    border: 2px solid whitesmoke;
    outline: none;
  }
`;

export const SearchIcon = styled.img`
  cursor: pointer;
  position: absolute;
  right: 8%;
  top: 11px;
`;
